import { useState, useContext } from 'react';
import
{
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  StyledAccordionIcon,
  StyledAccordionLink,
} from './NavAccordion.styles';
import
{
  indexLink,
  indexNavLinks,
  rezzilPlayerLink,
  rezzilPlayerNavLinks,
  indexExpandedRoutes,
  rezzilPlayerExpandedRoutes
} from '../../../options/navLinks';
import SubscriptionNavLink from '../../Links/SubscriptionNavLink/SubscriptionNavLink';
import { Link as RouterLink } from 'react-router-dom';
import { hasCorrectLicence, hasCorrectRole } from '../../../utils/helpers/licenceHelper';
import { BaseContext } from '../../../providers/Global/BaseProvider';

const routeMatches = (activeRoute, routeList) =>
{
  console.log('routeMatch', activeRoute, activeRoute, routeList)
  return routeList.find(route => activeRoute.indexOf(route) === 0)
}

const NavAccordion = ({ isRezzilPlayer, activeRoute, disabled, onlyShowHeader, licences }) =>
{
  const baseContext = useContext(BaseContext);
  const [mainLink] = useState(isRezzilPlayer ? rezzilPlayerLink : indexLink);
  const [navLinks] = useState(isRezzilPlayer ? rezzilPlayerNavLinks : indexNavLinks);
  const [expandedRoutes] = useState(isRezzilPlayer ? rezzilPlayerExpandedRoutes : indexExpandedRoutes);
  console.log('nav', navLinks);
  return (
    <StyledAccordion
      expanded={routeMatches(activeRoute, expandedRoutes)}
    >
      <StyledAccordionLink
        component={RouterLink}
        to={mainLink.isExternal ? { pathname: mainLink.route } : mainLink.route}
        target={mainLink.isExternal ? '_blank' : undefined}

      >
        <StyledAccordionSummary
          id={`${isRezzilPlayer ? 'rezzil-player' : 'index'}-nav-links`}
          expandIcon={<StyledAccordionIcon />}
          index={isRezzilPlayer ? undefined : 'true'}
          expanded={!expandedRoutes.includes(activeRoute) ? 'true' : undefined}
        >
          {mainLink && mainLink.icon}
        </StyledAccordionSummary>
      </StyledAccordionLink>
      {!onlyShowHeader &&
        <StyledAccordionDetails
          index={isRezzilPlayer ? undefined : 'true'}
          disabled={disabled ? 'true' : undefined}
        >
          {
            navLinks && navLinks.map(({ icon, name, route, isExternal, licence, role }) => (
              hasCorrectRole(role, name) &&
                hasCorrectLicence(licence, baseContext.baseData.licences) &&
              <SubscriptionNavLink
                key={name}
                icon={icon}
                name={name}
                route={route}
                isExternal={isExternal}
                active={activeRoute === route}
                disabled={disabled}
              />
            ))
          }
        </StyledAccordionDetails>
      }
    </StyledAccordion>
  );
};

export default NavAccordion;
